import styled from "styled-components";

export const ContainerFooter = styled.footer`
    padding: 12px;
    background-color: var(--light-1);
    border: 0;
    border-radius: 8px;
    margin-top: 12px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
    box-sizing: border-box;
    &.presential {
        background-color: var(--light-blue-0);
    }
    & h5 {
        font-weight: 700;
        font-size: 14px;
        margin: 0;
    }
    & ul{
        margin: 0;
        padding-left: 18px;
    }
    & li {
        font-size: 14px;
    }
    & a {
        text-decoration: none;
    }
`;
export const FooterTitle = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    gap: 5px;
    margin-top: 0;
    & span {
        display: grid;
        place-items: center;
    }
    & h3 {
        min-width: max-content;
        font-size: 14px;
        font-weight: 400;
        margin: 0;
        word-wrap: normal;
        word-break: normal;
    }
    &::after, &::before {
        display: block;
        content: "";
        width: 100%;
        border-top: 1px solid var(--light-blue-1);
    }
    &::after {
        margin-left: 5px;
    }
    &::before {
        margin-right: 5px;
    }
`;
